import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import {
  entityReducerMap,
  IEntityList,
  IEntityState,
  IFilteredLists,
  initialListState,
} from '../entity-data/entity-data.reducer';
import { TrackedTime } from './models/tracked-time.model';
import {
  ActionsEnum,
  SetDraftTrackedTime,
  SetDraftTrackedTimeError,
} from './tracked-time-data.actions';
import { IError } from '../entity-data/entity-data.data';
import { EntityTypesEnum } from '../../app.enum';
import { DEFAULT_SEARCH_PARAMS } from './tracked-time-data.data';

// feature name
export const FEATURE_NAME = 'tracked-time-data';

// state interface
export interface IState extends IEntityState {
  draftTrackedTime: TrackedTime;
  draftTrackedTimeError: IError;
}

// initial states of store
export const intialTrackedTimeListState: IEntityList = {
  ...initialListState,
  searchParams: DEFAULT_SEARCH_PARAMS,
};

export const initialFilteredListsState: IFilteredLists = {
  unbilled: intialTrackedTimeListState,
  billed: intialTrackedTimeListState,
  search: intialTrackedTimeListState,
};

export const initialState: IState = {
  filteredLists: initialFilteredListsState,
  editingEntity: null,
  selectedEntities: null,
  masterError: null,
  draftTrackedTime: null,
  draftTrackedTimeError: null,
  dispatchedResponse: null,
};

// reducer
const reducerFn = handleActions(
  {
    ...entityReducerMap<IState>(),
    [ActionsEnum.SET_DRAFT_TRACKED_TIME]: function (
      state: IState,
      { payload }: SetDraftTrackedTime
    ): IState {
      const { trackedTime } = payload;

      return {
        ...state,
        draftTrackedTime: trackedTime,
      };
    },
    [ActionsEnum.CLEAR_DRAFT_TRACKED_TIME]: function (state: IState): IState {
      return {
        ...state,
        draftTrackedTime: null,
        draftTrackedTimeError: null,
      };
    },
    [ActionsEnum.SET_DRAFT_TRACKED_TIME_ERROR]: function (
      state: IState,
      { payload }: SetDraftTrackedTimeError
    ): IState {
      const { error, data } = payload;
      const draftTrackedTimeError: IError = {
        error,
        data,
      };

      return {
        ...state,
        draftTrackedTimeError,
      };
    },
  } as any,
  initialState
);

// filter actions by entityType
export function reducer(state: IState = initialState, action: any) {
  return action.payload &&
    action.payload.entityType === EntityTypesEnum.tracked_time
    ? reducerFn(state, action)
    : state;
}

// selectors
export const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export function getDraftTrackedTime() {
  return createSelector(
    selectFeature,
    (state: IState) => state.draftTrackedTime
  );
}

export function getDraftTrackedTimeError() {
  return createSelector(
    selectFeature,
    (state: IState) => state.draftTrackedTimeError
  );
}
